import '../../styles/ChartsBarsCSS/DashedBarProgress.css';

const DashedProgressBar = ({ progress, color, shadow, name, reportCount }) => {
  const dashes = 5;
  const progressPerDash = 100 / dashes;
  const filledDashes = Math.floor(progress / progressPerDash);
  const partialFill = (progress % progressPerDash) / progressPerDash * 100;

  return (
    <div className={`progress-container${shadow === true ? " shadow-lg " : ""}`} style={{ marginTop: "1rem" }}>
      <div style={{ color: `${color}` }} className="progress-label df">{progress ?? 0}/100</div>
      <div className="dashed-progress-bar mt-4 mx-auto px-4">
        {[...Array(dashes)].map((_, index) => (
          <div
            key={index}
            className="dash"
            style={{
              background: index < filledDashes
                ? `${color}`
                : index === filledDashes
                  ? `linear-gradient(to right, ${color} ${partialFill}%, #e6e6e6 ${partialFill}%)`
                  : '#e6e6e6'
            }}
          ></div>
        ))}
      </div>
      {shadow === false ? "" : (
        <>
          <div className="progress-subtext-dash mt-4">{name}</div>
          <p><b>({reportCount} {reportCount > 1 ? "Audits" : "Audit"})</b></p>
        </>
      )}
    </div>
  );
};

export default DashedProgressBar;
